import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class GrayStoneFloor1 extends Floor {
	static key = "GrayStoneFloor1";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): GrayStoneFloor1 {
		const f = new GrayStoneFloor1(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
